﻿// page data

export function pensionGuidancePageData(state = {}, action) {
    switch (action.type) {
        case 'PENSION_GUIDANCE_DECLARATION_DATA_LOADED':
            return {
                ...state,
                ...action.pensionGuidancePageData
            };

        default:
            return state;
    }
}

export function pensionGuidanceSavedResult(state = {}, action) {
    switch(action.type) {
        case 'PENSION_GUIDANCE_FORM_SAVED_RESULT':
            return {
                ...state,
                ...action.pensionGuidanceSavedResult
            };
        default:
            return state;
    }
}

// forms

export function pensionGuidanceFormInputs(state = {}, action) {
    switch (action.type) {
        case 'PENSION_GUIDANCE_FORM_INPUT_REMOVED':
            const {
                [action.questionId]: _,
                ...newState
            } = state;

            return newState;

        case 'PENSION_GUIDANCE_FORM_INPUT_UPDATED':
            return {
                ...state,
                [action.inputData.id]: action.inputData
            };
        default:
            return state;
    }
}

export function pensionGuidanceRepeatedInputs(state = {}, action) {
    switch (action.type) {
        case 'PENSION_GUIDANCE_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state
                    ? state[action.groupId] + 1
                    : 1
            };
        case 'PENSION_GUIDANCE_REMOVE_REPEAT_FORM_INPUT':
            return {
                ...state,
                [action.groupId]: action.groupId in state
                    ? state[action.groupId] - 1
                    : 1
            };
        default:
            return state;
    }
}

export function pensionGuidanceStatus(state = {valid: false}, action) {
    switch (action.type) {
        case 'PENSION_GUIDANCE_FORM_STATUS':
            return {
                valid: action.valid
            };

        default:
            return state;
    }
}
